import script from "./MypageSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MypageSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MypageSidebar.vue?vue&type=style&index=0&id=a8e26712&scoped=true&lang=scss"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8e26712"]])

export default __exports__